import React , { useState , useEffect , useContext } from "react";
import { useNavigate  } from "react-router-dom";
import  { WebAssetsContext }  from "../App";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
const  Product = (props) => {

  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const HandleClickOnEdit = (id='') => 
    {
      navigate("/admin/products/edit/"+id);
    }

    const HandleClickOnPriceHistory = (id='') => 
    {
      navigate("/admin/products/price-history/"+id);
    }
    const [products, setProducts] = useState([]);
    const fetchData = () => {
      fetch(api+"getproducts")
        .then(res => res.json())
        .then((result) => {
            if(result.status == true)
            {
              setProducts(result.response);
            }
          }
        )
      }

  const HandleClickOnDelete = async (id='') => 
  {
    Swal.fire({  
      title: 'Are you sure you want to delete it ?',  
      text: "Once deleted, you will not be able to get it again!",
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        try {
        const resJson =   Delete(id);
        resJson.then(function(output) {
              if(output.status == true)
              {
                Swal.fire({  
                  title: 'Deleted!',  
                  text: "Product has been deleted successfully.",
                  icon: 'success'
                }).then((finalresult) => {
                    if (finalresult.isConfirmed) {
                      fetchData();
                    }
                });
              }
          });
       
          } catch (err) {
          console.log(err);
        }
        
      } 
    });
    
    
  }
  const Delete = async (id='') => 
  {
    const res =  await fetch(api+"deleteProduct", {
            method: "POST",
            body: JSON.stringify({id: id}),
          });
          let resJson = await res.json();
          return resJson;
    }
    
    useEffect(() => {
        fetchData();
    },[])
   

  return (
    <>
     <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                        <div className="pt-4 pl-4 pr-4">
                        <div className="card-header pl-0 pr-0 w-50 float-left">
                                    <h4 className="headercolor">Commodity Product List</h4>
                                </div>
                                <div className="float-right">
                                          <button onClick={() => navigate("/admin/products/add")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-plus"></i> Add Commodity Product</button>
                                    </div>
                                    </div>
                            <div className="card-body pl-4 pr-4 pb-4 pt-0">
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th className="text-center">S.NO</th>
                                                <th  width={'250px'} >Product</th>
                                                <th>Available Quantity</th>
                                                <th>Current Price</th>
                                                <th>Quick Buy</th>
                                                <th>Status</th>
                                                <th className="text-right">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {products.length > 0 ? products.map((product , i)  => (
                                            <tr key={i}>
                                                <td className="text-center bggreys">{i + 1}</td>
                                                
                                                <td className="bggreys">
                                                  {product.name.toUpperCase()}
                                                  <p className="m-0"><small>{product.full_name}</small></p>
                                                </td>
                                              
                                                <td>{product.qty}</td>
                                                <td>{props.currencySymbol()}{product.price}</td>
                                                <td>
                                                { product.quick_buy == 'YES' ? <div className="badge badge-success">YES</div> : <div className="badge badge-danger">NO</div>}
                                                </td>

                                                <td>
                                                { product.status == '1' ? <div className="badge badge-success">Active</div> : <div className="badge badge-danger">In-Active</div>}
                                                </td>
                                                <td className="text-right">
                                                <button  role="button"
                                                  id={'pricehistory_'+product.id} onClick={() => HandleClickOnPriceHistory(product.id)} 
                                                  className="btn btn-icon btn-primary mr-2" data-tooltip-content="View Price History">
                                                    <i className="fas fa-dollar-sign"></i>
                                                    </button>
                                                  <Tooltip anchorId={'pricehistory_'+product.id}  />

                                                  <button  role="button"
                                                  id={'edit_'+product.id} onClick={() => HandleClickOnEdit(product.id)} 
                                                  className="btn btn-icon btn-primary mr-2" data-tooltip-content="Edit">
                                                    <i className="far fa-edit"></i>
                                                    </button>
                                                  <Tooltip anchorId={'edit_'+product.id}  />

                                                  <button role="button"  id={'delete_'+product.id}  onClick={() => HandleClickOnDelete(product.id)} className="btn btn-icon btn-danger" data-tooltip-content="Delete" ><i className="far fa-trash-alt"></i></button>
                                                  <Tooltip anchorId={'delete_'+product.id}  />
                                                </td>
                                            </tr>
                                            ))  : 

                                            <tr><td colSpan="10" className="text-center">Data not yet found. </td></tr> 
                                           }
                                            
                                          </tbody>
                                    </table>
                                  </div>
                            </div>
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Product;
